import { useEffect } from 'react';

import { Toast } from '@/components/Toast/Toast.tsx';
import { helpers } from '@/helpers.ts';
import { MessageTypesUI } from '@/enums/viewEnums.ts';
import { ServerError as IServerError } from '@/api/config.ts';

export const ServerError = ({
  error,
  close
}: {
  error: IServerError | null;
  close: () => void;
}) => {
  useEffect(() => {
    if (error && error.response?.data) {
      const message =
        typeof error.response.data === 'object' &&
        'message' in error.response.data
          ? String(error.response.data.message)
          : '';

      if (message) {
        helpers.toast({
          id: MessageTypesUI.TYPE_SYSTEM_ERROR,
          content: (
            <Toast type={MessageTypesUI.TYPE_SYSTEM_ERROR} msg={message} />
          ),
          options: {
            onClose: close
          }
        });
      }
    }
  }, [error]);

  return null;
};
